module.exports = __webpack_public_path__ + "static/media/hover_year@x2.0bf4b87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/hover_year@x2.png
// module id = 189
// module chunks = 0